import api from '../api'

const url = "/account"

export default {
  login(payload) {
    return api.post(`${url}/login/`, payload)
  },
  forget(payload) {
    return api.post(`${url}/forget/`, payload)
  },
  resetPassword(payload) {
    return api.post(`${url}/resetPassword/`, payload)
  },
  changePassword(payload) {
    return api.post(`${url}/changePassword/`, payload)
  },
  getProfile() {
    return api.get(`${url}/profile/`)
  },
  updateProfile(payload) {
    return api.patch(`${url}/profile/`, payload)
  },
  settings() {
    return api.get(`/settings/site-config/`)
  }
}
